/**
 * FileName : index.ts
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2021-07-03 19:47:04
 * Description :
 * -----
 * Last Modified: 2024-06-05 16:15:30
 * Modified By :
 * -----
 * Copyright (c) 2021 Magina Corporation. All rights reserved.
 */


import { RouterConfig } from 'src/router/types';
import {lazy} from 'react';

const opreateRoleRouterConfig: RouterConfig[] = [
    {
        key: 'Users&Roles Mgnt',
        title: 'menuTitleOpreatorMgnt',
        icon: 'UserMenuSVG',
        subs: [
            {
                key: 'Roles Mgnt',
                route: '/home/roleManage/list',
                title: 'menuTitleRoleMgnt',
                component: lazy(() => import('src/pages/opreatorMgnt/roleManage')),
            },
            {
                key: 'Users Mgnt',
                route: '/home/userManage/list',
                title: 'menuTitleOperatorMgnt',
                component: lazy(() => import('src/pages/opreatorMgnt/userMange')),
            },
            {
                key: 'Ad Mapping Mgnt',
                route: '/home/user&roles/AdMappingMgnt',
                title: 'menuTitleAdMappingMgnt',
                component: lazy(() => import('src/pages/opreatorMgnt/AdMappingMgnt/index')),
            },
        ],
    },
];

export default opreateRoleRouterConfig;
